export default __webpack_public_path__ + "static/media/delete.e6630edf.svg";